import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import axios from "axios"
import { API_URL, sitename } from "../../../constants/constants"
import { useLocation } from "react-router-dom/cjs/react-router-dom"

const Freebets = () => {
  const [freeSpins, setFreeSpins] = useState([])
  const location = useLocation()
  const currentPath = location.pathname

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = `${API_URL}/slotegrator/getallfreeSpin`
        const params =
          currentPath === "/promotions/AutometedFreeSpin"
            ? { autofreespin: true }
            : {}
        const response = await axios.get(url, { params })
        const data = response?.data?.data || []
        setFreeSpins(data)
      } catch (error) {
        console.error("Error fetching free spin data:", error)
      }
    }

    fetchData()
  }, [currentPath])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Freebets" />
        </Container>
        <Table data={freeSpins} />
      </div>
    </React.Fragment>
  )
}

export default Freebets
